import styled from "styled-components"

export const Main = styled.div`
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Wrapper = styled.div`
  width: 83.3%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 71px 0 111px 0;

  @media (max-width: 1149px) {
    width: 82.5%;
    flex-wrap: wrap;
  }

  @media (max-width: 799px) {
    width: 88.88%;
  }

  & > img {
    width: 320px;
    height: 97.88px;
  }
`

export const IconsBar = styled.div`
  height: 86px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 1149px) {
    height: auto;
    flex-wrap: wrap;
    gap: 60px;
  }

  @media (max-width: 799px) {
    gap: 70px;
  }
`
export const IconsBox = styled.div`
  height: 100%;
  max-width: 205px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1149px) {
    justify-content: flex-start;
    gap: 10px;
    width: calc(50% - 40px);
    max-width: unset;
  }

  @media (max-width: 799px) {
    width: 100%;
  }

  @media (min-width: 1400px) {
    max-width: 250px;
  }

  p {
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 2.1rem;
    letter-spacing: 0.06em;
    color: #fdfdfd;
    text-align: center;
  }
`
